import Papers from "./Papers";

export default Papers;
